export default "__VITE_ASSET__Di5SxGz1__"